import moment, { Moment } from 'moment';

const DATE_FORMAT = 'YYYY-MM-DD';

/** Sunday of the ISO week that contains the start date. */
export function getOngoingJobEndDate(startDate: string): Moment {
    return moment(startDate, DATE_FORMAT).endOf('isoWeek');
}

/**
 * Consecutive dates from startDate through the Sunday of that same ISO week.
 * e.g. Wed 2026-07-22 → ['2026-07-22', ..., '2026-07-26']
 */
export function getOngoingJobDates(startDate: string): string[] {
    const start = moment(startDate, DATE_FORMAT).startOf('day');
    const end = getOngoingJobEndDate(startDate).startOf('day');
    const dates: string[] = [];
    const current = start.clone();

    while (current.isSameOrBefore(end, 'day')) {
        dates.push(current.format(DATE_FORMAT));
        current.add(1, 'day');
    }

    return dates;
}
